module.exports = __webpack_public_path__ + "img/analytics-disabled.f642c124.svg";